<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline" style="position: relative">
        <a-form-item class="name" label="课程名称">
          <a-input
            class="form-cell"
            type="text"
            v-model="queryParam.courseName"
          ></a-input>
        </a-form-item>

        <a-form-item label="时间">
          <a-range-picker
            format="YYYY-MM-DD HH:mm:ss"
            v-model="queryParam.time"
            :showTime="{
              hideDisabledOptions: true,
              defaultValue: [
                moment('00:00:00', 'HH:mm:ss'),
                moment('23:59:59', 'HH:mm:ss'),
              ],
            }"
          />
        </a-form-item>
        <a-form-item class="search-oper">
          <a-button @click="resetReq()">重置</a-button>
          <a-button type="primary" @click="searchCourse()">查询</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="li-inner">
      <!-- 表格数据 -->
      <div class="list-title" style="position: relative">
        <span>推荐列表</span>
        <a-button
          style="position: absolute; right: 10px"
          type="primary"
          icon="plus"
          @click="$refs.personForm.init('listadd')"
          >添加推荐</a-button
        >
      </div>
      <a-table
        :columns="columns"
        :dataSource="Recommendlist"
        class="c-table"
        :pagination="pagination"
        :loading="loading"
        @change="tableChange"
        :rowKey="getRowKey"
      >
        <span slot="recommendName" slot-scope="text, record">
          <template>
            <div>{{ record.recommendName }}</div>
          </template>
        </span>

        <span slot="gradeScope" slot-scope="text, record">
          <template>
            <div>{{ record.intro }}</div>
          </template>
        </span>

        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="$refs.courseDetail.init('tuijian', record)">详情</a>
            <!-- 

						<a @click="go('courseDetail', { key: record.offeringId })">详情
						</a> -->
            <a @click="$refs.xiugai.init('update', record)">修改</a>
            <a-divider type="vertical" />
            <a @click="deletePerson(record)">删除</a>
          </template>
        </span>
      </a-table>
      <manager-form-modal
        ref="personForm"
        @addPerson="addPerson"
      ></manager-form-modal>
      <manager-form-modal
        ref="xiugai"
        @updateData="updateData"
      ></manager-form-modal>
      <course-detail-modal
        ref="courseDetail"
        @updateCourse="updateCourse"
      ></course-detail-modal>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import ManagerFormModal from './ManagerFormModal'
import CourseDetailModal from './CourseDetailModal'
import course from '../../api/course'

import school from '../../api/school'

import institution from '../../api/institution'

import { analysisAddress } from '../../utils/address'

const columns = [
  {
    title: '课程名称',
    dataIndex: 'courseName',
    width: 100,
  },

  {
    title: '推荐理由',
    dataIndex: 'gradeScope',
    scopedSlots: {
      customRender: 'gradeScope',
    },
    width: 110,
  },
  {
    title: '推荐时间',
    dataIndex: 'gmtCreate',
    sorter: true,
    width: 110,
  },

  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 100,
  },
]

export default {
  name: 'RecommendedCourse',
  data() {
    return {
      dataSource: [],
      columns,
      likeNumber: '50',
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        showLessItems: true,
        showSizeChanger: true,
      }, //分页数据对象
      queryParam: {}, //查询参数
      loading: true,
      queryParams: {}, //用于改变数据时的查询参数
      Recommendlist: [], //推荐课程数据
      columns: JSON.parse(JSON.stringify(columns)), //列标识数据
      queryParam: {}, //查询参数

      loading: true,
      tabIndex: '',
      waitCheckCount: 0,
      providerList: [], //提供方列表
      visible1: false, //补课

      attendDate: '2021-07-22',
      form: {
        name: '',
        region: undefined,
        date1: undefined,
        date2: undefined,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    }
  },

  components: {
    ManagerFormModal,
    CourseDetailModal,
  },

  methods: {
    moment,
    //选择提供方类型
    headleChangeOfferingType() {
      // == '1' 学校
      const _fun =
        this.queryParam.offeringType == '1'
          ? school.selectSearch
          : institution.selectSearch
      _fun().then((res) => {
        this.providerList = res.data
      })
    },
    getRowKey(record, index) {
      return index;
    },
    updateCourse(course) {
      for (let i in this.courseList) {
        if (this.courseList[i].id == course.id) {
          this.$set(this.courseList, i, course)
        }
      }
    },

    setTab(key) {
      this.tabIndex = key
      this.resetReq()
      this.Recommendlist(this.queryParam)
    },

    resetReq() {
      this.queryParam = {}
      if (this.tabIndex == 'status') {
        this.queryParam.status = '0'
      }
    },

    //更新当前修改的数据
    updateData() {
      this.Recommend()
      // for (let i in this.Recommendlist) {
      // 	if (this.Recommendlist[i].id == value.id) {
      // 		this.$set(this.Recommendlist, i, value);
      // 	}
      // }
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地区的话，把地区解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.Recommend(obj)
    },

    //查询课程
    searchCourse() {
      let tempTime = this.queryParam.time
      if (tempTime) {
        this.queryParam.startTime = tempTime[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.endTime = tempTime[1].format('YYYY-MM-DD HH:mm:ss')
      }
      this.queryParam.currentPage = 1
      this.queryParam.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`

      this.Recommend(this.queryParam)
    },

    //推荐课程列表
    Recommend(params) {
      this.loading = true
      var req = utils.common.copy(params)
      // this.$set(req, 'schoolId', this.$store.getters.userInfo.schoolId )
      delete req.time
      console.log('req', req)

      course.Recommendlist_all(req).then((res) => {
        console.log('当前推荐课程列表', res.data.list)
        this.Recommendlist = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    getWaitCheckCount() {
      course.getWaitCount().then((res) => {
        console.log(res)
        this.waitCheckCount = res.data
      })
    },
    //新增推荐
    addPerson() {
      this.dataSource = []
      this.Recommend()
    },

    //删除
    deletePerson(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',

        onOk() {
          course.deleteRecommend(value.id).then((res) => {
            self.$message.success('删除成功')

            self.deleteCourseData(self.dataSource, value.id)
            self.Recommend()
          })
        },
      })
    },

    //删除数据
    deleteCourseData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
        }
      }
    },
  },
  created() {
    if (this.$route.query.params) {
      console.log(
        'this.$route.query.params',
        JSON.parse(this.$route.query.params)
      )
      this.queryParam = JSON.parse(this.$route.query.params)
      console.log('this.queryParam', this.queryParam)
    } else {
      this.queryParam = {}
    }
    this.Recommend(this.queryParam)
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.tab-type {
  line-height: 40px;
  margin-bottom: 20px;

  .item-active {
    color: $primary-color;
    border-bottom: 2px solid $primary-color;
  }
}

.search-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
  border-radius: 8px;
}

.li-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
  border-radius: 8px;
}

.cl-inner {
}

.search-oper {
  position: absolute;
  right: 10px;

  button {
    margin: 0px 5px;
  }
}

.list-oper {
  margin: 20px 0px 30px;
}

.list-title {
  span {
    font-weight: bold;
  }

  padding: 20px 10px;
}

.download {
  display: inline-block;
  margin-left: 20px;
  text-decoration: underline;
  color: $primary-color-dark;
  position: relative;
}

a {
  margin: 5px;
}
</style>
